export default {
  viewData:[],
  footerData:[],
  globalLoading:false,
  olCourseList: {list:[]},
  coursList: {list:[]},
  footer_nav:[],
  teacherList:{list:[]},
  org:'',   //选中的门店
  isShowStoreModel:false,
  orgId:null, //公司ID
  stores:[],
  shopList: {list:[]},
  isShowNoData:false,
  p_org_id:''
}
